export default "__VITE_ASSET__C3vG9jCT__"